import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home.tsx";
import Business from "./Pages/Business";
import ContactUs from "./Pages/ContactUs";
import MediaKit from "./Pages/media/MediaKit.tsx";
import WhyChooseAptech from "./Pages/AboutUs/WhyChooseAptechPage.tsx";
import Alliances from "./Pages/AboutUs/Alliances.tsx";
import OverView from "./Pages/AboutUs/OverView.tsx";
import Social from "./Pages/AboutUs/Social.tsx";
import Leadership from "./Pages/AboutUs/Leadership.tsx";
import Achievement from "./Pages/StudentWorld/Achievement.tsx";
import StudentWork from "./Pages/StudentWorld/StudentWork.tsx";
import StudentSupport from "./Pages/StudentWorld/StudentSupport.tsx";
import StudentPlacement from "./Pages/StudentWorld/StudentPlacement.tsx";
import PartnerWithAptech from "./Pages/PartnerWithAptech.tsx";
import EventsAtAptech from "./Pages/EventsAtAptech.tsx";
import CareerWithAptech from "./Pages/CareerWithAptech.tsx";
import AwardWithAptech from "./Pages/AwardWithAptech.tsx";
import ProConnect from "./Pages/StudentWorld/ProConnect.tsx";
import News from "./Pages/media/News.tsx";
import "./_theme.scss";
import "./_common.scss";
import PressRelease from "./Pages/media/PressRelease.tsx";
import Investor from "./Pages/Investor/Investor.tsx";
import BoardOfDirectors from "./Pages/Investor/BoardOfDirectors.tsx";
import ShareHolder from "./Pages/Investor/ShareHolder.tsx";
import StockExchange from "./Pages/Investor/StockExchange.tsx";
import Header from "./components/CommonComponents/Header.jsx";
import Footer from "./components/CommonComponents/Footer.tsx";
import ScrollToTop from "./components/CommonComponents/ScrollToTop.tsx";
import Report from "./Pages/Investor/Report.tsx";
import NewsAndNotificationPage from "./Pages/Investor/NewsAndNotificationPage.tsx";
import Conference from "./Pages/Investor/Conference.tsx";
import Disclaimer from "./Pages/Disclaimer.tsx";
import Sitemap from "./Pages/Sitemap.tsx";
import Presentation from "./Pages/Investor/Presentation.tsx";
import InstitutionalBusiness from "./components/OurBussiness/InstitutionalBusiness.tsx";
import GlobalRetails from "./components/OurBussiness/GlobalRetails.tsx";
import MissionVision from "./components/AboutUs/MissionAndVision/MissionAndVision.tsx";
import AwardsAndAchievement from "./components/AboutUs/AwardsAndAchievement/AwardsAndAchievement.tsx";
import OverviewBusiness from "./components/OurBussiness/Overview.tsx";
import IndividualBusiness from "./components/OurBussiness/IndividualBusiness.tsx";
import Blogs from "./components/OurBlogs/Blogs.tsx";
import BlogDetails from "./components/OurBlogs/BlogDetails.tsx";

import AptechAssessmentAndTesting from "./components/OurBussiness/InstitutionalBusiness/AptechAssessmentAndTesting/AptechAssessmentAndTesting.tsx";
import AptechTrainingSolution from "./components/OurBussiness/InstitutionalBusiness/AptechTrainingSolutions/AptechTrainingSolutions.tsx";
import EIC from "./components/OurBussiness/InstitutionalBusiness/EIC/EIC.tsx";

const App = () => {
  return (
    <BrowserRouter>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<OverView />} />
        <Route
          path="/about-us/why-choose-aptech"
          element={<WhyChooseAptech />}
        />
        <Route path="/about-us/mission-vision" element={<MissionVision />} />
        <Route
          path="/about-us/award-achievement"
          element={<AwardsAndAchievement />}
        />

        <Route path="/about-us/alliances" element={<Alliances />} />
        <Route path="/about-us" element={<OverView />} />
        <Route
          path="/about-us/corporate-social-responsibility"
          element={<Social />}
        />
        <Route path="/about-us/our-leadership-team" element={<Leadership />} />
        <Route path="/our-businesses" element={<Business />} />

        <Route path="/our-businesses" element={<OverviewBusiness />} />
        <Route
          path="/our-businesses/institutional-business"
          element={<InstitutionalBusiness />}
        />
        <Route
          path="/our-businesses/institutional-business/aptech-assessment-and-testing"
          element={<AptechAssessmentAndTesting />}
        />
        <Route
          path="/our-businesses/institutional-business/aptech-training-solutions"
          element={<AptechTrainingSolution />}
        />
        <Route
          path="/our-businesses/institutional-business/eic"
          element={<EIC />}
        />
        <Route
          path="/our-businesses/domestic-retail"
          element={<IndividualBusiness />}
        />
        <Route path="/our-blogs" element={<Blogs />} />
        <Route path="/our-blogs/:title" element={<BlogDetails />} />

        <Route
          path="/our-businesses/international-retail"
          element={<GlobalRetails />}
        />

        <Route path="students-world" element={<Achievement />} />
        <Route
          path="students-world/alumni-achievements"
          element={<Achievement />}
        />
        <Route path="/students-world/students-work" element={<StudentWork />} />
        <Route
          path="/students-world/students-support"
          element={<StudentSupport />}
        />
        <Route
          path="/students-world/placements-at-aptech"
          element={<StudentPlacement />}
        />
        <Route path="/students-world/proconnect" element={<ProConnect />} />

        <Route path="/contact-us" element={<ContactUs />} />

        <Route path="/news-and-media" element={<PressRelease />} />
        <Route path="/news-and-media/aptech-in-news" element={<News />} />
        <Route path="/news-and-media/media-kit" element={<MediaKit />} />
        <Route
          path="/news-and-media/press-releases"
          element={<PressRelease />}
        />
        <Route path="/investors" element={<Investor />} />
        <Route
          path="/investors/board-of-directors"
          element={<BoardOfDirectors />}
        />
        <Route path="/investors/shareholders" element={<ShareHolder />} />
        <Route path="/investors/conference-table" element={<Conference />} />

        <Route
          path="/investors/filings-with-stock-exchanges"
          element={<StockExchange />}
        />
        <Route path="/investors/results-and-reports" element={<Report />} />
        <Route
          path="/investors/news-and-notifications"
          element={<NewsAndNotificationPage />}
        />
        <Route path="/investors/presentation" element={<Presentation />} />

        <Route path="/partner-with-aptech" element={<PartnerWithAptech />} />
        <Route path="/events-at-aptech" element={<EventsAtAptech />} />
        <Route path="/careers-with-aptech" element={<CareerWithAptech />} />
        <Route path="/awards-at-aptech" element={<AwardWithAptech />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/sitemap" element={<Sitemap />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
